import { ChangeDetectionStrategy, Component, OnChanges, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

import { FilterNavigation } from 'ish-core/models/filter-navigation/filter-navigation.model';
import { URLFormParams } from 'ish-core/utils/url-form-params';

@Component({
  selector: 'ish-filter-navigation-badges',
  templateUrl: './filter-navigation-badges.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, TranslateModule],
})
export class FilterNavigationBadgesComponent implements OnChanges {
  readonly filterNavigation = input.required<FilterNavigation>();
  readonly applyFilter = output<{
    searchParameter: URLFormParams;
  }>();
  readonly clearFilters = output<void>();
  selected: { searchParameter: URLFormParams; displayName: string; filterName: string }[];

  ngOnChanges() {
    this.selected = this.filterNavigation()?.filter?.reduce(
      (acc, filterElement) => [
        ...acc,
        ...filterElement.facets
          .filter(facet => facet.selected)
          .map(({ searchParameter, displayName }) => ({
            filterName: filterElement.name,
            displayName,
            searchParameter,
          })),
      ],
      []
    );
  }

  apply(searchParameter: URLFormParams) {
    this.applyFilter.emit({ searchParameter });
  }

  clear() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.clearFilters.emit();
  }
}
